.hashtag {
  appearance: none;
  border: none;
  background: none;
  font-size: inherit;
  margin: 0;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
}
